import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import loadable from "@loadable/component";
import useIsWebView from "@hooks/useIsWebview";
import { useLocation } from "react-router-dom";
import stl from "./StaticPage.module.css";
import extractStaticPageSlug from "@/pages/static-page/utils/extractStaticPageSlug";
import classnames from "classnames";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
var fallback = {
  fallback: null
};
var TermsAndConditions = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-terms-TermsAndConditions";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-terms-TermsAndConditions" */"./components/terms/TermsAndConditions");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/terms/TermsAndConditions");
    }
    return eval('require.resolve')("./components/terms/TermsAndConditions");
  }
}, fallback);
var PrivacyPolicy = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-privacy-PrivacyPolicy";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-privacy-PrivacyPolicy" */"./components/privacy/PrivacyPolicy");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/privacy/PrivacyPolicy");
    }
    return eval('require.resolve')("./components/privacy/PrivacyPolicy");
  }
}, fallback);
var ReturnPolicy = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-return-policy-ReturnPolicy";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-return-policy-ReturnPolicy" */"./components/return-policy/ReturnPolicy");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/return-policy/ReturnPolicy");
    }
    return eval('require.resolve')("./components/return-policy/ReturnPolicy");
  }
}, fallback);
var StaticPage = function StaticPage() {
  var isWebView = useIsWebView();
  var location = useLocation();
  var slug = extractStaticPageSlug(location.pathname);
  var staticData = useFullPageData(PageNamesEnum.PAGE_NAME__PRIVACY_POLICY);
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    linksForSearch: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(_defineProperty(_defineProperty(_defineProperty({}, stl.PageWrapper, 1), "container", 1), "webViewDangerousHTMLContainer", isWebView))
  }, slug === "terms-landing" && /*#__PURE__*/React.createElement(TermsAndConditions, {
    content: staticData === null || staticData === void 0 ? void 0 : staticData.content,
    title: staticData === null || staticData === void 0 ? void 0 : staticData.title,
    published_date: staticData === null || staticData === void 0 ? void 0 : staticData.published_date
  }), slug === "privacy-policy" && /*#__PURE__*/React.createElement(PrivacyPolicy, {
    content: staticData === null || staticData === void 0 ? void 0 : staticData.content,
    title: staticData === null || staticData === void 0 ? void 0 : staticData.title,
    published_date: staticData === null || staticData === void 0 ? void 0 : staticData.published_date
  }), slug === "return-policy" && /*#__PURE__*/React.createElement(ReturnPolicy, {
    content: staticData === null || staticData === void 0 ? void 0 : staticData.content,
    title: staticData === null || staticData === void 0 ? void 0 : staticData.title,
    published_date: staticData === null || staticData === void 0 ? void 0 : staticData.published_date
  })));
};
export default StaticPage;